import {
  CANCEL_EDITION,
  CLEAN_ERROR,
  CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE,
  CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR,
  CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING,
  DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE,
  DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR,
  DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING,
  FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE,
  FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR,
  FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING,
  SORT,
  UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE,
  UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR,
  UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING,
} from 'services/GameHosting/DeploymentTemp/DependencyInstaller/types';
import { addNew, sort } from 'utils/functions';

const INITIAL_STATE = {
  dependencyDepTemp: [],
  sortBy: 'name',
  sortDirection: 'ASC',
  params: {},
  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,
  createIsCompleted: false,
  createIsPending: false,
  createIsError: null,
  updateIsCompleted: false,
  updateIsPending: false,
  updateIsError: null,
  deleteIsCompleted: false,
  deleteIsPending: false,
  deleteIsError: null,
};

const dependencyTemplateReducer = (
  state = {
    ...INITIAL_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        dependencyDepTemp: sort(action.data, {
          sortBy: state.sortBy,
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortDirection: state.sortDirection,
          sortSearchValue: (state.params as $TSFixMe).sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        fetchIsCompleted: false,
        fetchIsPending: true,
        fetchIsError: null,
      };
    case FETCH_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        fetchIsCompleted: true,
        fetchIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchIsError: action.error,
      };
    case CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        dependencyDepTemp: addNew(action.data, state.dependencyDepTemp),
        createIsCompleted: true,
        createIsPending: false,
        createIsError: null,
      };
    case CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        createIsCompleted: false,
        createIsPending: true,
        createIsError: null,
      };
    case CREATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        createIsCompleted: true,
        createIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        createIsError: action.error,
      };

    case UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const indexToUpdate = state.dependencyDepTemp.findIndex((x) => (x as $TSFixMe).id === action.data.id);

      return {
        ...state,
        dependencyDepTemp: state.dependencyDepTemp.map((item, index) => {
          if (index !== indexToUpdate) {
            return item;
          }

          return {
            // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
            ...item,

            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            ...action.data,
          };
        }),
        updateIsCompleted: true,
        updateIsPending: false,
        updateIsError: null,
      };
    }

    case UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        updateIsCompleted: false,
        updateIsPending: true,
        updateIsError: null,
      };
    case UPDATE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        updateIsCompleted: true,
        updateIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        updateIsError: action.error,
      };

    case DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const index = state.dependencyDepTemp.findIndex((x) => (x as $TSFixMe).id === action.data.id);

      return {
        ...state,
        dependencyDepTemp: [...state.dependencyDepTemp.slice(0, index), ...state.dependencyDepTemp.slice(index + 1)],
        deleteIsCompleted: true,
        deleteIsPending: false,
        deleteIsError: null,
      };
    }

    case DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        deleteIsCompleted: false,
        deleteIsPending: true,
        deleteIsError: null,
      };
    case DELETE_DEPENDENCY_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        deleteIsCompleted: true,
        deleteIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        deleteIsError: action.error,
      };
    case CLEAN_ERROR:
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (state[action.reducerProperty] && state[action.reducerProperty][action.errorIndex]) {
        return {
          ...state,

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          [action.reducerProperty]:
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            action.mode === 'property'
              ? null
              : // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                [...state[action.reducerProperty].slice(0, action.errorIndex), ...state[action.reducerProperty].slice(action.errorIndex + 1)],
        };
      }

      return {
        ...state,
      };

    case CANCEL_EDITION:
      return {
        ...state,
        dependencyDepTemp: state.dependencyDepTemp.filter((item) => (item as $TSFixMe).id),
      };
    case SORT:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        dependencyDepTemp: sort(state.dependencyDepTemp, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };

    case 'RESET_DEPENDENCY_DEPLOYMENT_TEMPLATE_REDUCER':
    case 'RESET_REDUCER':
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default dependencyTemplateReducer;
